<template>
    <span v-b-tooltip.hover title="Open Doc">
        <a :href="resourceUrl" target="_blank">
            <i class="open-resource fa fa-file-code-o pointer-action" variant="warning"></i
        ></a>
    </span>
</template>

<script>
export default {
    props: {
        resourceUrl: {
            required: true,
            type: String,
        },
    },
}
</script>

<style></style>
